import { useFeatureFlagsStore } from "@/stores/featureFlags";

const routes = [
  {
    path: "/profile/:id",
    name: "profile.guest",
    component: () => import("@/pages/ProfileGuestPage.vue"),
  },
  {
    path: "/profile",
    component: () => import("@/pages/ProfileOwnPage.vue"),

    children: [
      {
        path: "",
        name: "profile",
        component: () => import("@/components/profile/MyProfile.vue"),
      },
      {
        path: "boosts",
        name: "profile.boosts",
        component: () => import("@/components/profile/MyBoosts.vue"),
      },
      {
        path: "wallet",
        name: "profile.wallet",
        component: () => import("@/components/profile/MyWallet.vue"),
      },
      {
        path: "settings",
        name: "profile.settings",
        component: () => import("@/components/profile/MySettings.vue"),
      },
    ],
  },
  {
    path: "/discovery",
    name: "discovery",
    component: () => {
      const featureFlagsStore = useFeatureFlagsStore();
      const useSwipeDiscovery = featureFlagsStore.isVerticalSwipingEnabled;

      if (useSwipeDiscovery) {
        return import("@/pages/DiscoverySwipePage.vue");
      }
      return import("@/pages/DiscoveryPage.vue");
    },
  },
  {
    path: "/likes",
    name: "wholikedme",
    component: () => import("@/pages/WhoLikedMePage.vue"),
  },
  {
    path: "/dialogs",
    name: "dialogs",
    component: () => import("@/pages/DialogsPage.vue"),
  },
  {
    path: "/dialogs/:dialogId",
    name: "dialog",
    component: () => import("@/pages/DialogPage.vue"),
  },
  {
    path: "/pulse",
    component: () => import("@/pages/PulsePage.vue"),
    children: [
      {
        path: "",
        name: "pulse",
        component: () => import("@/components/pulse/PulsePostsList.vue"),
      },
      {
        path: "online",
        name: "pulse.online",
        component: () => import("@/components/pulse/PulseOnlineList.vue"),
      },
    ],
  },
];

export default routes.map((route) => {
  return { ...route, meta: { public: false } };
});
